/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_GateInputs */

const en_cmp_row_gate = /** @type {(inputs: Cmp_Row_GateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification gate`)
};

const id_cmp_row_gate = /** @type {(inputs: Cmp_Row_GateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerbang verifikasi`)
};

/**
* | output |
* | --- |
* | "Verification gate" |
*
* @param {Cmp_Row_GateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_gate = /** @type {((inputs?: Cmp_Row_GateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_GateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_gate(inputs)
	return en_cmp_row_gate(inputs)
});